<script>
  /**
   * @typedef {Object} RewardDetails
   * @property {number} rate - The reward rate.
   * @property {boolean} enabled - Indicates if the reward is enabled.
   * @property {?number} minimum_spend - The minimum spend to qualify for the reward.
   * @property {?number} maximum_reward - The maximum reward that can be earned.
   */

  /**
   * @typedef {Object} Rewards
   * @property {RewardDetails} standard - Standard reward details.
   * @property {RewardDetails} first_visit - First visit reward details.
   * @property {?string} cashback_text - Custom cashback text.
   * @property {?string} custom_text - Custom text for rewards.
   */

  /** @type {Rewards} Refers to location rewards object in API */
  export let rewards;

  /** @type {string} Naming of reward based on publisher (e.g., 'cashback', 'bonuskroner') */
  export let reward_text;

  /** @type {string} Naming of title reward based on publisher (e.g., 'cashback', 'bonuskroner') */
  export let reward_text_title = '';

  /**
   * @typedef {Object} CashbackLocationType
   * @property {string} value - Description of the cashback location type.
   * @property {string} description - Description of the cashback location type.
   */

  /** @type {CashbackLocationType} Cashback type content from API */
  export let cashbackLocationType;
</script>

<!-- @TODO - Needs to be remade differently.-->

{#if rewards.cashback_text}
  <span class="cashback_text">{rewards.cashback_text}</span>
{:else}
  <div class="reward">
    <div>
      {#if reward_text_title}
        <span class="title">{reward_text_title}</span>
      {:else}
        <span class="title">{reward_text}</span>
      {/if}
    </div>

    {#if rewards.first_visit.rate && rewards.first_visit.enabled && rewards.first_visit.rate !== rewards.standard.rate}
      <span>
        Første gang:
        <b>{rewards.first_visit.rate} %</b>
      </span>
    {/if}
    {#if rewards.first_visit.enabled}
      <span>{rewards.first_visit.rate !== rewards.standard.rate ? 'Herefter: ' : reward_text + ': '}<strong>{rewards.standard.rate}</strong> %</span>
    {:else}
      <span> {reward_text} <strong>{rewards.standard.rate}</strong> %</span>
    {/if}
  </div>
{/if}

{#if cashbackLocationType.value}
  <div class="cashback_type">
    {cashbackLocationType.description}
  </div>
{/if}

{#if rewards.standard.minimum_spend || rewards.standard.maximum_reward || rewards.first_visit.minimum_spend || rewards.first_visit.maximum_reward}
  <div class="reward-conditions">
    {#each ['first_visit', 'standard'] as rewardType}
      {#if rewards[rewardType].minimum_spend || rewards[rewardType].maximum_reward}
        <div>
          <p class="title">{rewardType === 'first_visit' ? 'Første gang:' : 'Herefter:'}</p>

          {#if rewards[rewardType].minimum_spend}
            <p>Du skal minimum købe for <span>{rewards[rewardType].minimum_spend} kr.</span> for at optjene {reward_text}</p>
          {/if}

          {#if rewards[rewardType].maximum_reward}
            <p>
              Du kan optjene max <span>{rewards[rewardType].maximum_reward} kr.</span>
              {rewardType === 'first_visit' ? 'på dit første køb.' : 'pr. køb.'}
            </p>
          {/if}
        </div>
      {/if}
    {/each}
  </div>
{/if}
